__turbopack_context__.v({
  "container": "OurWorldBlock-module__5zbSyG__container",
  "fadeInItems": "OurWorldBlock-module__5zbSyG__fadeInItems",
  "header": "OurWorldBlock-module__5zbSyG__header",
  "latest": "OurWorldBlock-module__5zbSyG__latest",
  "latestAnimation": "OurWorldBlock-module__5zbSyG__latestAnimation",
  "noTitle": "OurWorldBlock-module__5zbSyG__noTitle",
  "overlay": "OurWorldBlock-module__5zbSyG__overlay",
  "overlayArticles": "OurWorldBlock-module__5zbSyG__overlayArticles",
  "overlayBtn": "OurWorldBlock-module__5zbSyG__overlayBtn",
  "overlayCloseBtn": "OurWorldBlock-module__5zbSyG__overlayCloseBtn",
  "overlayContent": "OurWorldBlock-module__5zbSyG__overlayContent",
  "post": "OurWorldBlock-module__5zbSyG__post",
  "postImg": "OurWorldBlock-module__5zbSyG__postImg",
  "postImgWrap": "OurWorldBlock-module__5zbSyG__postImgWrap",
  "postSubtitle": "OurWorldBlock-module__5zbSyG__postSubtitle",
  "postTitle": "OurWorldBlock-module__5zbSyG__postTitle",
  "postWrap": "OurWorldBlock-module__5zbSyG__postWrap",
  "posts": "OurWorldBlock-module__5zbSyG__posts",
  "spacing--lg": "OurWorldBlock-module__5zbSyG__spacing--lg",
  "spacing--md": "OurWorldBlock-module__5zbSyG__spacing--md",
  "spacing--sm": "OurWorldBlock-module__5zbSyG__spacing--sm",
  "spacing--xl": "OurWorldBlock-module__5zbSyG__spacing--xl",
  "spacing--xs": "OurWorldBlock-module__5zbSyG__spacing--xs",
  "spacing--xxl": "OurWorldBlock-module__5zbSyG__spacing--xxl",
  "spacing--xxs": "OurWorldBlock-module__5zbSyG__spacing--xxs",
  "spacing--xxxl": "OurWorldBlock-module__5zbSyG__spacing--xxxl",
  "spacing--xxxs": "OurWorldBlock-module__5zbSyG__spacing--xxxs",
});
